// JavaScript для button
import { onReady } from '../base/init.js';

onReady(function () {
  // Код для button
});
